import React, {useEffect, useState} from 'react';
import { mostrarPlantillas } from '../../redux/reducers/plantillasReducers';
import Strings from "../../assets/strings";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPlantilla} from "../../redux/types/IPlantilla";

type Props = {
    value?:number
    name?:string
    label?:string
    onChange?:React.ChangeEventHandler<HTMLSelectElement>,//(e:React.ChangeEvent<HTMLInputElement>)=>void
    required?:boolean
    autoDefault?:boolean
    hideWithoutContent?:boolean
}
export default function SelectPlantilla({value,onChange, hideWithoutContent, autoDefault}:Props) {

    const dispatch = useAppDispatch();
    const {list} = useAppSelector(state => state.plantillas);
    const [options, setOptions] = useState<IPlantilla[]>()

    useEffect(() => {
        dispatch(mostrarPlantillas({mostrarDelSistema:true}))
    }, [dispatch]);

    useEffect(() => {
        let lista = [...(list??[])];

        if(list){
            if(hideWithoutContent){
                lista  = lista.filter(p=>!!p.contenido?.length)
            }
            if(autoDefault && onChange && !value){

                let def = lista.find(i=>i.porDefecto);
                if(def){
                    onChange({target:{value:def.id!.toString() }} as any)

                } else if(lista[0]){
                    onChange({target:{value:lista[0].id!.toString() }} as any)
                }
            }

            setOptions(lista);
        }else {
            setOptions([])
        }
    }, [setOptions,list,value, autoDefault,onChange, hideWithoutContent]);


    return (
        <select value={value??""} onChange={onChange} style={{width: 200, height:31}} >
            <option value={""}>{Strings.seleccione}</option>
            {options?.filter(o=>!o.registroDelSistema).map(opc=>
                <option value={opc.id} key={opc.id}>{opc.nombre}</option>
            )}
            <optgroup label={Strings.registrosDelSistema}>
                {options?.filter(o=>o.registroDelSistema).map(opc=>
                    <option value={opc.id} key={opc.id}>{opc.nombre}</option>
                )}
            </optgroup>
        </select>
    )
}
